import { create } from 'zustand'

interface MaskState {
  isMasked: boolean
  toggleMask: () => void
}

export const useMaskStore = create<MaskState>((set) => ({
  isMasked: true, // Always start masked for demo safety
  toggleMask: () => set((state) => ({ isMasked: !state.isMasked })),
}))
